import { LOGOUT } from './LogOutAction.js';

const SET_TAB = 'tokenized/tab/SET_TAB';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case SET_TAB:
      return {
        ...state,
        [action.area]: action.activeTab,
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

export function onSetTab(area, activeTab) {
  return { type: SET_TAB, area, activeTab };
}
